import { html, LitElement, css, unsafeCSS } from 'lit';
import { setTitle, trackPage } from '../shared/utils';

import '../components/challenge';

import style from './challenges.scss';

export class ChallengesPage extends LitElement {

    static get properties() {
        return {            
            challenges: Array
        }
    }

    constructor() {
        super();     
        this.challenges = [];   
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();
        trackPage();      
        setTitle('Challenges');
        this.fetchData();
    }

    async fetchData() {                                
        let ret = await fetch(`./api/allchallenges`);      
        let json = await ret.json(); 
        this.challenges = json.challenges;        
        this.update();                
    }

    render() {  
        if(this.challenges.length === 0)
            return html``;                                 
        return html`
            <h1>Challenges</h1>
            ${this.challenges.map(val=>{
                return html`
                    <challenge-component id=${val.uid}></challenge-component>
                `;
            })}
        `;
    }
}

customElements.define('challenges-page', ChallengesPage);